import React from 'react';
import PropTypes from 'prop-types';

import { Alert } from 'react-bootstrap-5';

import Button from 'shared/button';
import Modal from 'components/modal';

export default function ImmediateRemindersModal({
  handleSelection,
  show,
  userNames,
  onHide,
  ...props
}) {
  return (
    <Modal {...props} show={show}>
      <Modal.Header>
        Reminder Email Warning
      </Modal.Header>

      <Modal.Body>
        <Alert variant="warning">
          <p>This update would cause your reminder notification emails to be due.</p>
          <p>
            The following users would receive reminder notifications:
            <ul>
              {userNames.map(userName => (
                <li key={userName}>{userName}</li>
              ))}
            </ul>
          </p>
          <p>Would you like to send these notifications or skip them?</p>
        </Alert>
      </Modal.Body>

      <Modal.Footer>
        <Button.Cancel name="cancel" onClick={onHide}/>
        <Button.Secondary name="skip" onClick={()=> handleSelection(false)}>
          Skip
        </Button.Secondary>
        <Button.Primary name="send" onClick={() => handleSelection(true)}>
          Send
        </Button.Primary>
      </Modal.Footer>
    </Modal>
  );
}

ImmediateRemindersModal.propTypes = {
  handleSelection: PropTypes.func.isRequired,
  show: PropTypes.bool,
  userNames: PropTypes.arrayOf(PropTypes.string).isRequired,
  onHide: PropTypes.func.isRequired,
};
